<template>
  <div>
    <div style="position: relative">
      <img
        :src="news.titlePicture"
        :width="imgwidth + 'px'"
        :height="imgHeight + 'px'"
        class="img_index"
      />
      <h1 class="h_title h_title0">{{ news.title }}</h1>
      <img
        class="titlePic1"
        :src="news.titlePicture1"
        :width="img1width + 'px'"
      />
      <img
        class="titlePic2"
        :src="news.titlePicture2"
        :width="img2width + 'px'"
      />
      <img
        class="titlePic3"
        :src="news.titlePicture3"
        :width="img3width + 'px'"
      />
      <img
        class="titlePic4"
        :src="news.titlePicture4"
        :width="img1width + 'px'"
      />
      <img
        class="titlePic5"
        :src="news.titlePicture5"
        :width="img2width + 'px'"
      />
    </div>

    <div class="margin_top">
      <el-image
        :src="news.honorBackGround"
        style="width: 100%; height: 450px; z-index: -1; padding-top: 30px"
      />

      <el-row style="margin-top: -450px" type="flex" justify="space-around">
        <el-col :span="8">
          <div style="background-color: rgba(250, 236, 106, 0.72)">
            <el-image
              :src="news.honorTopBackGround"
              style="width: 100%; height: 50px"
            />
            <h2 style="margin-top: -50px; color: #000000">获得荣誉</h2>
            <div
              style="
                display: flex;
                flex-direction: column;
                text-align: left;
                padding: 0 10px 30px;
              "
            >
              <span
                v-for="(honor, index) in news.honorList"
                :key="index"
                style="line-height: 25px"
                >{{ honor }}</span
              >
            </div>
          </div>
        </el-col>
        <el-col :span="4" class="col_image">
          <el-image
            :src="news.honorPictureList[0]"
            class="img_honor"
            style="width: 160px; height: 220px"
          />
        </el-col>
        <el-col :span="9" class="col_image">
          <el-image
            :src="news.honorPictureList[1]"
            class="img_honor"
            style="width: 100%"
          />
        </el-col>
      </el-row>
      <el-row :gutter="30" style="margin: 20px 0 0">
        <el-col
          :span="6"
          v-for="(picture, index) in news.honorPictureList"
          :key="index"
          v-if="index > 1"
          class="col_image"
          style="height: 220px"
        >
          <el-image :src="picture" class="img_honor" style="width: 100%" />
        </el-col>
      </el-row>
    </div>

    <div class="margin_top">
      <el-image
        :src="news.newsBackground"
        style="width: 100%; height: 800px; opacity: 25%; z-index: 1"
      />

      <el-row :gutter="20" style="margin: -820px 0 0">
        <el-col :span="15" class="col_image">
          <div>
            <el-image
              :src="news.newsTopBackground"
              style="width: 100%; height: 200px; z-index: -1"
            />
            <h5 style="margin: -60px 0 0; color: #000000">
              {{ news.newsTitle1 }}
            </h5>
            <h5 style="margin-top: 0; color: #000000">{{ news.newsTitle2 }}</h5>
            <div
              class="img_honor"
              style="
                display: flex;
                flex-direction: column;
                text-align: left;
                padding: 0 10px 0;
              "
            >
              <p
                v-for="(honor, index) in news.newsContent"
                :key="index"
                style="font-size: 12px; text-indent: 2em"
              >
                {{ honor + "\n\n" }}
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="9" class="col_image">
          <div>
            <el-image
              :src="news.patentTopBackground"
              style="width: 100%; height: 200px; z-index: -1"
            />
            <h2 style="margin-top: -185px; color: #000000">专利授权</h2>
            <div style="padding: 0 50px 36px; text-align: left">
              <h4 style="margin: 10px 0; color: #000000">
                关于产品 About Product
              </h4>
              <span>{{ news.patent }}</span>
            </div>
            <el-image
              v-for="(item, index) in news.patentPicture"
              :key="index"
              :src="item"
              class="img_honor"
              style="width: 100%"
            />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "News",
  data() {
    return {
      news: global.news,
      imgHeight: 525,
      imgwidth: 0,
      img1width: 360,
      img2width: 360,
      img3width: 290,
    };
  },
  created() {
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.handleResize);
    this.imgwidth = window.innerWidth;
    this.handleResize();
  },
  destroyed() {
    // 移除窗口大小变化事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.imgwidth = window.innerWidth;
  },
  methods: {
    // 窗口大小变化时更新页面宽度值
    handleResize() {
      this.imgHeight = window.innerWidth / 3;
      this.imgwidth = window.innerWidth;
      this.img1width = (window.innerWidth * 20) / 100;
      this.img2width = (window.innerWidth * 20) / 100;
      this.img3width = (window.innerWidth * 18) / 100;
      this.img4width = (window.innerWidth * 20) / 100;
      this.img5width = (window.innerWidth * 20) / 100;
      console.log(this.img1width);
    },
  },
};
</script>

<style scoped>
.h_title0 {
  color: #ffffff;
  position: absolute;
  top: 7%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.h_title {
  color: #ffffff;
  /* margin-top: -500px; */
  text-shadow: 2px 5px 5px rgba(0, 0, 0, 0.5);
}

.titlePic1 {
  position: absolute;
  top: 18%;
  left: 13%;
}

.titlePic2 {
  position: absolute;
  top: 64%;
  left: 13%;
}

.titlePic3 {
  position: absolute;
  top: 18%;
  left: 50%;
  transform: translateX(-50%);
}

.titlePic4 {
  position: absolute;
  top: 18%;
  right: 13%;
}

.titlePic5 {
  position: absolute;
  top: 64%;
  right: 13%;
}

.col_image {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img_honor {
  box-shadow: -2px 10px 10px 0 rgba(0, 0, 0, 0.5);
}

.img_index {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/news/news.vue